export const modernATSPro = {
  id: 'modern-ats-pro',
  version: 2,
  renderer: 'enterprise',
  name: 'Modern ATS Pro',
  layout: 'two-column',
  theme: 'modern-teal',
  persona: ['software', 'frontend', 'javascript', 'react', 'engineering'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 40,
    visual: 35,
    executive: 10,
    student: 15
  },
  sectionOrder: ['personal-info', 'summary', 'projects', 'experience', 'education', 'skills', 'languages', 'certifications'],
  components: {
    header: 'header-classic',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-section'
  },
  metadata: {
    industry: ['Tech Startups', 'SaaS', 'Digital Agencies'],
    companies: ['Google', 'Microsoft', 'Amazon', 'Atlassian', 'Stripe', 'Figma', 'Canva'],
    ats: ['Greenhouse', 'Lever', 'Ashby', 'Workday'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: true,
    icons: true,
    density: 'comfortable',
    columns: 2,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    careerStage: 'Professional',
    recommendedFor: ['Full Stack Engineers', 'Frontend Developers', 'Mobile Engineers', 'DevOps Specialists'],
    avoidFor: ['Investment Bankers', 'Corporate Lawyers', 'Academic Researchers'],
    dna: ['Modern', 'Visual', 'Sidebar-Teal', 'Tech-Native', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 90,
      scanningSpeed: 95,
      visualAppeal: 94
    },
    hiringManager: {
      firstImpression: "Clean, organized, forward-thinking tech professional",
      scanningStyle: "F-Pattern scanning with focus on sidebar skills and main projects",
      preferredStructure: "Summary and projects prominent in main body, education in sidebar",
      dislikes: ["Wall of text paragraphs", "Dense academic publications lists", "No links to GitHub/portfolio"]
    },
    strategy: {
      goal: "Provide a visually appealing two-column layout while preserving high ATS scannability",
      focus: "Sidebar skills matching job keywords and project technical stack callouts",
      avoid: ["Unformatted visual bars", "Complex graphics blocks"]
    },
    psychology: {
      coreTraits: ["Innovation", "Modernity", "Technical competence", "Adaptability"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: false,
      sidebar: true
    },
    aiPrompt: {
      writingStyle: "Use punchy, tech-driven bullet points emphasizing individual contributions, scale, and exact tools used.",
      rewriteStyle: "Tech-focused, metric-driven, crisp"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'two-column': {
      component: 'two-column',
      slots: {
        header: ['personal-info'],
        sidebar: ['education', 'skills', 'languages'],
        main: ['summary', 'experience', 'projects']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '20px',
        '--layout-sidebar-bg': '#0F766E',         // Teal sidebar background
        '--layout-sidebar-text': '#FFFFFF',        // White text on teal
        '--layout-sidebar-padding': '14px 12px',  // Inner padding
        '--layout-sidebar-border': 'none',
      }
    },
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'skills', 'projects', 'education', 'languages']
      }
    }
  },
  styleOverrides: {
    '--heading-text-transform': 'none',
    '--heading-letter-spacing': 'normal',
    '--section-heading-weight': '600',
    '--color-text-main': '#2F2F2F',
    '--color-text-light': '#777777'
  }
};
export default modernATSPro;
